module.exports = __webpack_public_path__ + "img/scroll-icon-4.98563e62.png";